import React from "react";
import InvoiceList from "./pages/InvoiceList";

function App() {
  return <InvoiceList />;
}

export default App;